module.exports = __webpack_public_path__ + "img/accessories-l.df2d0043.svg";